import { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn, dispatchLead } from "../../lib/utils";
import icon from "../../assets/icons/telegram.svg";
import externalIcon from "../../assets/icons/external.svg";

export type TelegramButtonProps = ComponentPropsWithoutRef<"a"> & {
  href: string;
  ariaLabel: string;
  children: ReactNode;
};

export const TelegramButton = ({
  href,
  ariaLabel,
  className,
  children,
  ...props
}: TelegramButtonProps) => {
  return (
    <a
      role="button"
      className={cn("cta-button", className)}
      aria-label={ariaLabel}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={dispatchLead()}
      {...props}
    >
      <span className="flex items-center gap-4 justify-center">
        <img src={icon} alt="Ícone WhatsApp" className="w-7 h-7" />
        {children}
        <img src={externalIcon} alt="Ícone externo" className="w-6 h-6" />
      </span>
    </a>
  );
};
